import { render } from "./NotFound.vue?vue&type=template&id=3c86450c&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=3c86450c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c86450c"

export default script